import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AdminUsersPage } from './admin-users';
import { DirectivesModule } from '../../directives/directives.module';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

@NgModule({
  declarations: [
    AdminUsersPage,
  ],
  imports: [
    IonicPageModule.forChild(AdminUsersPage),
    DirectivesModule,
    NgxDatatableModule
  ],
})
export class AdminUsersPageModule {}



// WEBPACK FOOTER //
// ./src/pages/admin-users/admin-users.module.ts